import { Form, Modal } from "react-bootstrap";
import "./WidgetParameter.css"
import SrvButton from "../../../../components/global/SrvButton";
import SrvButtonLink from "../../../../components/global/SrvButtonLink";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import ParameterIcon from "./ParameterIcon";
import immutabilityUpdate from 'immutability-helper'
import WidgetParameterItem from "./WidgetParameterItem";
import BlockName from "../BlockName";
import axios from "axios";
import ErrorAdd from "../../../../util/ErrorAdd";

function WidgetParameter({ idTask, idWidget, number, idObject, onlyRead, name, nameChange, showTracker, showTrackerChange, widgetUpdateHandler, idProject, added }) {

    const [addModal, setAddModal] = useState(false);
    const [addLoading, setAddLoading] = useState(false);

    //const stateParameterListByObjectProject = useSelector((state) => state.parameterListByObjectProject);//Параметры  
    const stateWidget = useSelector((state) => state.widgetData);//Данные для виджета

    const [data, setData] = useState([]);
    const [widgetName, setWidgetName] = useState(null);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState(false);
    const [listByObjectProject, setListByObjectProject] = useState([]);

    useEffect(() => {
        setWidgetName(name);
    }, [name]);
    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    useEffect(() => {
        if (idTask !== null & idObject !== null & idProject !== null) {
            setData(stateWidget.dataParameter.filter(a => a.Widget_Number === number));
        }
    }, [idTask, idObject, idProject, stateWidget.dataParameter]);


    //Добавит/удалит параметр
    function changeParameterHandler(id, check) {
        if (check) {
            const order = data.length + 1;
            setData([...data, { ID_Parameter: id, Width: 50, Order: order, Name: listByObjectProject.filter(a => a.ID === id).length > 0 && listByObjectProject.filter(a => a.ID === id)[0].Name }]);
        }
        else {
            setData(data.filter(a => a.ID_Parameter !== id));
        }
    }
    //Сортировка перетаскинием
    function moveParam({ dragIndex, hoverIndex }) {

        const list_new = immutabilityUpdate(data, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, data[dragIndex]],
            ],
        })

        const list_new_order = list_new.map((item, index) => {
            return { ...item, Order: index };
        });

        setData(list_new_order)
    }
    //Изменит ширину параметра
    function changeWidthHandler(idParameter, val) {
        setData(data.map((item) => {
            if (item.ID_Parameter === idParameter) {
                return { ...item, Width: val }
            }
            return item
        }))
    }
    //Сохранит изменения
    function updateHandler() {
        setLoading(true);

        if (idObject === 1) {
            axios.post('/api_tracker/task/widgetParameterSetMass', { ID_Task: idTask, Widget_Number: number, Items: data })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 2) {
            axios.post('/api_tracker/taskR/widgetParameterSetMass', { ID_TaskR: idTask, Widget_Number: number, Items: data })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskWidgetParameterSetMass', { ID_Board_Task: idTask, Widget_Number: number, Items: data })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setEdit(false);
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }

        //Обновляем настройки виджета
        widgetUpdateHandler();
    }

    function addParameterModal() {
        setAddLoading(true);
        setAddModal(true);

        axios.get('/api_tracker/parameter/listByObjectProject', { params: { ID_Object: idObject, ID_Project: idProject } })
            .then((res) => {
                if (res.data.Status === 1) {
                    setListByObjectProject(a => res.data.Data);
                    setAddLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setAddLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setAddLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            {stateWidget.dataParameter.filter(a => a.Widget_Number === number).length === 0 && (
                <div className="text-center">
                    <SrvButton typeBtn='add' size='lg' textBtn="Добавить параметры" onClick={() => setEdit(true)} />
                </div>
            )}

            {addModal === true && (
                <Modal show={addModal} onHide={() => setAddModal(false)} size="sm">
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setAddModal(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">Выберите параметры</div>

                        {addLoading === true ? (
                            <div className="loader_01 mt-30 mb-30"></div>
                        ) : (
                            <>
                                <div className="row mt-15">
                                    <div className="col-md-12">
                                        {listByObjectProject.length === 0 && (
                                            <div className="text-center mt-15 mb-15"><b>Нет доступных параметров.</b> <br></br> <i>Для добавления параметров зайдите в справочники - параметры</i></div>
                                        )}
                                        {listByObjectProject.map((item) => (
                                            <div key={item.ID} className="col-md-12" >
                                                {
                                                    data.filter(a => a.ID_Parameter === item.ID).length > 0 ?
                                                        (
                                                            <div>
                                                                <a href="" className="mr-2 badge badge-secondary card_param_btn" style={{ opacity: "50%" }} onClick={(e) => { e.preventDefault(); changeParameterHandler(item.ID, false) }}>

                                                                    <FontAwesomeIcon icon={ParameterIcon(item.ID_Type)} className="mr-5 text-bolder" />
                                                                    {item.Name}
                                                                </a>
                                                                <FontAwesomeIcon icon={faCheck} className="ml-5 text-success text-bolder" />
                                                            </div>
                                                        )
                                                        :
                                                        (
                                                            <div>
                                                                <a href="" className="mr-2 badge badge-secondary card_param_btn" onClick={(e) => { e.preventDefault(); changeParameterHandler(item.ID, true) }}>
                                                                    <FontAwesomeIcon icon={ParameterIcon(item.ID_Type)} className="mr-5 text-bolder" />
                                                                    {item.Name}
                                                                </a>
                                                            </div>
                                                        )
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-md-12 text-center">
                                        <SrvButton typeBtn="save" size='lg' onClick={() => setAddModal(false)} />
                                    </div>
                                </div>
                            </>
                        )}

                    </Modal.Body>
                </Modal>
            )}
            {edit === true && (
                <>
                    <Modal show={edit} onHide={() => setEdit(false)} >
                        <Modal.Body>
                            <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            <div className="modal_title text-center">Редактирование параметров</div>
                            <BlockName name={name} setName={nameChange} updateHandler={widgetUpdateHandler} />
                            <div className="col-md-12 text-end">
                                <SrvButtonLink typeBtn="add" onClick={() => addParameterModal()} />
                            </div>
                            <div className="row">
                                {data.sort((a, b) => a.Order - b.Order).map((item, index) => (
                                    <WidgetParameterItem
                                        key={item.ID_Parameter}
                                        idParameter={item.ID_Parameter}
                                        idObject={idObject}
                                        idTask={idTask}
                                        width={item.Width}
                                        widthHandler={changeWidthHandler}
                                        idType={item.ID_Type}
                                        name={item.Name}
                                        moveParam={moveParam}
                                        index={index}
                                        model={item}
                                        edit={edit}
                                    />
                                ))}
                            </div>
                            {idObject === 2 && (
                                <div className="mt-15">
                                    <Form.Check // prettier-ignore
                                        type="switch"
                                        id="show_tracker_switch"
                                        label="Отображать в «Текущих задачах?»"
                                        defaultChecked={showTracker}
                                        onChange={(e) => showTrackerChange(e.target.checked)}
                                    />
                                </div>
                            )}
                            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                            <div className="mt-15" style={{ textAlign: "center" }}>
                                <SrvButton typeBtn="save" size='lg' onClick={() => updateHandler()} disabled={loading} />
                            </div>
                        </Modal.Body>
                    </Modal>
                </>
            )}
            {stateWidget.dataParameter.filter(a => a.Widget_Number === number).length > 0 && (
                <div className="card_param_block_list">
                    <div className="card_param_btn_edit">
                        {onlyRead !== true && (<SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setEdit(!edit)} />)}
                    </div>

                    <div className="row mr-0">
                        {stateWidget.dataParameter.filter(a => a.Widget_Number === number).sort((a, b) => a.Order - b.Order).map((item, index) => (
                            <WidgetParameterItem
                                key={item.ID_Parameter}
                                idParameter={item.ID_Parameter}
                                idObject={idObject}
                                idTask={idTask}
                                width={item.Width}
                                widthHandler={changeWidthHandler}
                                idType={item.ID_Type}
                                name={item.Name}
                                moveParam={moveParam}
                                index={index}
                                model={item}
                                edit={false}
                                onlyRead={onlyRead}
                            />
                        ))}


                    </div>

                </div>

            )}
        </>
    )
}

export default WidgetParameter;